module.exports = __webpack_public_path__ + "static/media/canvas_wallart.64e0d3ca.png";